import { ComponentProps, FC } from 'react'
import { Text } from '../../Text'

export const Description: FC<ComponentProps<typeof Text>> = ({ children, ...rest }) => {
  return (
    <Text size="14" type="secondary" {...rest}>
      {children}
    </Text>
  )
}
